import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";

export const GroupReportTable: React.FC<BaseTablePropsType> = ({ rows }) => {
	const groupReportTableHeaders = [
		"Group ID",
		"Group Name",
		"Branch Name",
		"Loan Officer",
		"Activation Date",
		"Status",
	];
	return (
		<BaseTable headers={groupReportTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => (
					<TableRow key={index}>
						<TableCell>{row?.id}</TableCell>
						<TableCell>{row?.name}</TableCell>
						<TableCell>{row?.branch}</TableCell>
						<TableCell>{row?.accountManager}</TableCell>
						<TableCell>{row?.activationDate}</TableCell>
						<TableCell>
							{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1) ||
								"NA"}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</BaseTable>
	);
};
